import { FileQuestion, Inbox, Search, AlertCircle } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './Button';

type EmptyStateVariant = 'default' | 'search' | 'error' | 'inbox';

interface EmptyStateProps {
  title?: string;
  description?: string;
  variant?: EmptyStateVariant;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
  children?: React.ReactNode;
}

const icons: Record<EmptyStateVariant, typeof Inbox> = {
  default: FileQuestion,
  search: Search,
  error: AlertCircle,
  inbox: Inbox
};

export function EmptyState({
  title = 'No data',
  description,
  variant = 'default',
  action,
  className,
  children
}: EmptyStateProps) {
  const Icon = icons[variant];

  return (
    <div className={cn('flex flex-col items-center justify-center py-12 text-center', className)}>
      <div className="mb-4 rounded-full bg-muted p-4">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="mb-1 text-lg font-semibold">{title}</h3>
      {description && <p className="mb-4 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && (
        <Button onClick={action.onClick} className="mt-2">
          {action.label}
        </Button>
      )}
      {children}
    </div>
  );
}
